/**
 * Zod schemas for the "top-N outreach targeting" job-dashboard controls
 * (GitHub issue "[Email] Top-N targeting — queue outreach only for the
 * top-N best-fit candidates per job", milestone "Email & Outreach
 * Overhaul").
 *
 * Mirrors:
 *   - `GET /api/jobs/:jobId` (`apps/workers/src/api/jobs.ts`'s `getJob`) —
 *     read the job's current `outreach_top_n`.
 *   - `PATCH /api/jobs/:jobId` (`apps/workers/src/api/jobs.ts`'s
 *     `updateJob`) — save a new `outreach_top_n` from the dashboard's
 *     "top-N" control.
 *   - `POST /api/jobs/:jobId/outreach/next-batch`
 *     (`apps/workers/src/api/outreach/nextBatch.ts`) — the "Send next
 *     batch" action.
 */

import { z } from 'zod';

/** `GET /api/jobs/:jobId` / `PATCH /api/jobs/:jobId` response `data` shape
 *  — only the fields the job-dashboard's outreach-targeting UI needs. */
export const jobOutreachSettingsSchema = z.object({
  id: z.string(),
  title: z.string().nullable(),
  status: z.enum(['DRAFT', 'ACTIVE', 'PAUSED', 'CLOSED']),
  outreachTopN: z.number().int().positive(),
});
export type JobOutreachSettings = z.infer<typeof jobOutreachSettingsSchema>;

/** `POST /api/jobs/:jobId/outreach/next-batch` response `data` shape. */
export const nextOutreachBatchResponseSchema = z.object({
  job_id: z.string(),
  queued_count: z.number().int().nonnegative(),
  outreach_top_n: z.number().int().positive(),
});
export type NextOutreachBatchResponse = z.infer<typeof nextOutreachBatchResponseSchema>;
